<div class="task-progress-container">
<div>
  <ng-content></ng-content>
</div>

  <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">
    <span *ngIf="announceLoading">{{"progress.loading.status"|translate}}</span>
  </div>

  <div class="progressbar-container">
    <div class="b-p-container">
      <span id="b-p-textlabel" class="b-p-textlabel">{{"progress.label"|translate}}</span>
      <div class="b-p-progress">
        <div id="b-progress-bar"
             [style.width]="task?.progressPercent + '%'"
             class="b-progress-bar"
             role="progressbar"
             aria-labelledby="b-p-textlabel"
             aria-valuemin="0"
             aria-valuemax="100"
             [attr.aria-valuenow]="task?.progressPercent"
             [attr.aria-valuetext]="task?.progressPercent != null ? (task.progressPercent + '%') : null"></div>
      </div>
      <span id="b-p-label" class="b-p-label">{{task?.progressPercent}}%</span>
      <a href="" *ngIf="canCancel" (click)="onCancelTask();false"> Cancel</a>
    </div>
  </div>
</div>
